import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { InvoiceNode } from '@/apollo/graphql'
import { Button } from '@/components'
import { t } from '@/i18n'
import { customerDisplayLabel, print } from '@/utils'

const InvoiceInfo: React.FC<{
  node?: Partial<InvoiceNode>
  onClose?: () => void
}> = ({ node, onClose }) => {
  return (
    <div
      className={classNames('info-box mobile-modal scroll-sticky w-100', {
        open: !!Object.keys(node || {}).length,
      })}
    >
      <div className="main-info">
        <div className="close-box">
          <Button onClick={onClose}>
            <span className="icon-close"></span>
          </Button>
        </div>
        <div className="section-box">
          <div className="toolbox">
            <div className="title-box">
              <h4>{t('invoice_data')}</h4>
            </div>
            <div className="btn">
              <Button
                className="main-btn blue-outline"
                onClick={() => print('invoice', node?.id)}
              >
                <span className="icon-download"></span>
                {t('print')}
              </Button>
            </div>
          </div>

          <div className="data-list">
            <ul>
              <li>
                {t('deal_id')}
                <span>{node?.dealIds}</span>
              </li>
              <li>
                {t('customer')}
                <span>
                  <Link
                    to={`/${node?.customer?.id}/main`}
                    style={{ color: '#4094f7' }}
                  >
                    <span>{customerDisplayLabel(node?.customer)}</span>
                  </Link>
                </span>
                <span>{node?.customerName}</span>
              </li>
              <li>
                {t('phone')}
                <span>{node?.phone}</span>
              </li>
              <li>
                {t('invoice_number')}
                <span>{node?.id}</span>
              </li>
              <li>
                {t('production_date')}
                <span>{moment(node?.creationTime).format('DD/MM/YYYY')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceInfo
